import { createLoaderImp } from '../../../../components/ozmoit/common/loader-imp';
import { getAdmissionProcessesAction } from './actions';

const {
  useLoader: useAdmissionProcessesLoader,
  LoaderProvider: AdmissionProcessesLoaderProvider,
  LoaderConsumerSimple: AdmissionProcessesLoaderConsumer,
  useLoaderData,
} = createLoaderImp({
  action: getAdmissionProcessesAction,
});

export {
  useAdmissionProcessesLoader,
  AdmissionProcessesLoaderProvider,
  AdmissionProcessesLoaderConsumer,
  useLoaderData,
};
